import * as React from "react";

function SvgHidePassword(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0a2 2 0 00-2 2v30a2 2 0 002 2h30a2 2 0 002-2V2a2 2 0 00-2-2H2zm16.538 25.821l-1.602-2.29a6.686 6.686 0 01-6.626-6.688c0-.783.135-1.534.381-2.232L7.884 10.6a15.91 15.91 0 00-4.724 5.044 2.361 2.361 0 000 2.397c2.774 4.707 7.947 7.852 13.84 7.852.514 0 1.027-.024 1.538-.072zm5.652-1.608a15.954 15.954 0 006.65-6.172 2.361 2.361 0 000-2.397C28.066 10.937 22.893 7.792 17 7.792c-1.431 0-2.82.185-4.141.534l-2.51-3.572a1.18 1.18 0 00-1.645-.29l-.645.451a1.18 1.18 0 00-.29 1.644l15.883 22.372a1.18 1.18 0 001.644.29l.645-.45a1.18 1.18 0 00.29-1.645l-2.04-2.913zM17 10.153a6.686 6.686 0 016.69 6.69 6.664 6.664 0 01-1.632 4.38l-.95-1.332a5.115 5.115 0 00.406-5.457v.001a2.106 2.106 0 11-2.107-2.106h.002a5.125 5.125 0 00-3.955-.365l-.95-1.33c.772-.31 1.614-.481 2.496-.481zm-1.278 11.644l-3.814-5.448a5.117 5.117 0 003.814 5.448z"
        fill="#F7A246"
      />
    </svg>
  );
}

export default SvgHidePassword;
